var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col",class:`col-${_vm.cols}`},[_c('label',[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('input',{attrs:{"id":_vm.variableName,"type":"file","name":"uploadFile","accept":"application/pdf,application","required":_vm.required},on:{"change":_vm.uploadFile}})])
}
var staticRenderFns = []

export { render, staticRenderFns }